import { render, staticRenderFns } from "./form.vue?vue&type=template&id=a1cb79d8&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=a1cb79d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cb79d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1cb79d8')) {
      api.createRecord('a1cb79d8', component.options)
    } else {
      api.reload('a1cb79d8', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=a1cb79d8&scoped=true&", function () {
      api.rerender('a1cb79d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/pointLottery/form.vue"
export default component.exports